import React, {Component} from 'react';

import Layout from '../components/Layout/Layout';
import MainBlock from '../components/MainBlock/MainBlock';
import adaptiveHeight from "../helpers/adaptiveHeight";

export default class MainScreen extends Component {

  componentDidMount() {
    adaptiveHeight();
  }

  render() {
    return(
      <Layout page="main">
        <MainBlock
          history={this.props.history}
          params={this.props.match.params}
        />
      </Layout>
    )
  }
}